import React from 'react';
import { PageContainer } from '@/components/layout/PageContainer';
import { HelpCircle, LifeBuoy, MessageSquare } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";

// Placeholder FAQ data
const faqs = [
  {
    question: "How do I schedule an appointment?",
    answer: "You can schedule an appointment through the \"Appointments\" page by clicking the \"Book Appointment\" button, or by using the \"Schedule Appointment\" option after ordering tests."
  },
  {
    question: "Where can I find my test results?",
    answer: "Your test results are available on the \"Test Results\" page. You will be notified when new results are available."
  },
  {
    question: "How do I update my profile information?",
    answer: "Navigate to the \"Profile\" page using the side menu. You can edit your personal, contact, emergency, and insurance details there."
  },
  {
    question: "How can I message my doctor?",
    answer: "Go to the \"Messages\" page to send secure messages to your care team. You can view past conversations and start new ones."
  },
  {
    question: "What if I forget my password?",
    answer: "On the login page, click the \"Forgot Password\" link and follow the instructions to reset your password via email."
  }
];

const Help: React.FC = () => {
  return (
    <PageContainer
      title="Help & Support"
      description="Find answers to common questions and ways to contact support."
      icon={<HelpCircle />}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* FAQ Section */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <HelpCircle className="mr-2 h-5 w-5" />
              Frequently Asked Questions
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem value={`item-${index}`} key={index}>
                  <AccordionTrigger>{faq.question}</AccordionTrigger>
                  <AccordionContent>
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </CardContent>
        </Card>

        {/* Contact Section */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <LifeBuoy className="mr-2 h-5 w-5" />
              Contact Support
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-muted-foreground">
              If you need further assistance or have specific issues, please reach out to our support team.
            </p>
            <div className="space-y-2">
              <p><strong>Phone Support:</strong> 1-800-MED-CARE (Available Mon-Fri, 8 AM - 6 PM)</p>
              <p><strong>Email Support:</strong> support@kaimed.health</p>
            </div>
            <Button className="w-full">
              <MessageSquare className="mr-2 h-4 w-4" /> Send Secure Message
            </Button>
            <p className="text-xs text-muted-foreground">
              For medical emergencies, please call 911 or your local emergency number immediately.
            </p>
          </CardContent>
        </Card>
      </div>
    </PageContainer>
  );
};

export default Help; 